export default __webpack_public_path__ + "static/media/signal_verygood.8abfb110.svg";